import {DOCUMENT_TYPE} from "utils/constants";
import React, {Component} from "react";
import { CircleQuestionMark } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";
import arrowDown from "../../../assets/arrow-down-icon.png";
import { Tooltip } from "components/tooltip/Tooltip";
import { SHARED_TOOLTIP_ID } from "components/tooltip/AppTooltip.component";

export class SimulatorHeader extends Component {

    render() {
        let {toggle, docType, collapsed} = this.props;
        return (
            <div className="step-header align-items-center pe-0 cursor-pointer"
                 onClick={toggle}>
                <span>
                    <span className="d-inline-flex align-items-center">
                        <strong className="text-blue">{this.props.translate("workflowDetails.simulator.header")}</strong>
                        <span className="simulator-icon ms-2 d-flex"
                              data-for={SHARED_TOOLTIP_ID} data-tip="simulator-header-info-tooltip">
                            <CircleQuestionMark size={ICON_SIZE.SMALL}/>
                        </span>
                        <Tooltip
                            id="simulator-header-info-tooltip"
                            content={() => this.props.translate("workflowDetails.simulator.headerInfo")}
                        />
                    </span>

                    <br/>
                    <span className="text-muted">
                        {this.props.translate("workflowDetails.simulator.headerSubtext", this.props.translate("documentType." + DOCUMENT_TYPE.asString(docType)))}
                    </span>

                    <img className={`me-3 arrow-icon float-right ${collapsed ? '' : 'right'}`}
                         src={arrowDown}
                         alt="arrow down"/>
                </span>
            </div>
        )

    }
}